module.exports = __webpack_public_path__ + "static/img/pc_hz_daohui_img.d4109fc.png";